export default __webpack_public_path__ + "static/media/launchlines.5e038e9a.gif";